// extracted by mini-css-extract-plugin
module.exports = {"noData":"InteriorPage_noData__3xTx3","backgroundColor":"InteriorPage_backgroundColor__3nuWA"};